import * as Sentry from '@sentry/react';

import { importAWSPackage } from '@nw/shared/utils';

import { UploadToAWSRequest } from './types';

class S3FileUploader {
  s3Client;
  upload;
  constructor() {
    this.s3Client = null;
    this.upload = null;
  }

  getFileName = (fileProps) => {
    const {
      fileExtension,
      overrideBucketPath,
      uuid,
      higherHierarchy,
      lowerHierarchy
    } = fileProps;

    return fileExtension
      ? higherHierarchy && lowerHierarchy
        ? `${uuid}_${higherHierarchy}_${lowerHierarchy}_${overrideBucketPath}_${new Date().getTime()}.${fileExtension}`
        : `${uuid}_${new Date().getTime()}.${fileExtension}`
      : `${uuid}_${new Date().getTime()}`;
  };

  configureAWS = async (fileUploadConfig): Promise<void> => {
    const { regionName, accessKeyId, secretAccessKey, awsSessionToken } =
      fileUploadConfig;
    const AWS = await importAWSPackage();
    const credentials = new AWS.Credentials(
      accessKeyId,
      secretAccessKey,
      awsSessionToken
    );

    AWS.config.update({
      region: regionName,
      credentials: credentials
    });
  };

  uploadToAWS = async (
    requestObject: UploadToAWSRequest,
    fileUploadConfig
  ): Promise<any> => {
    const { file, getCustomFileName, acl, getS3FileUploaderUrl } =
      requestObject;
    const { bucketName } = fileUploadConfig;
    const s3FilePath = getS3FileUploaderUrl
      ? getS3FileUploaderUrl(getCustomFileName)
      : getCustomFileName;

    const s3UploadParams = {
      Bucket: bucketName,
      Key: s3FilePath,
      Body: file,
      ACL: acl
    };

    const AWS = await importAWSPackage();
    return new Promise((resolve, reject) => {
      const upload = new AWS.S3.ManagedUpload({
        params: s3UploadParams
      });
      const promise = upload.promise();
      Sentry.addBreadcrumb({
        type: 'info',
        category: 'S3FileUploader',
        message: `In upload to AWS`,
        data: {
          params: s3UploadParams
        }
      });
      promise.then(
        (data) => {
          resolve(data);
        },
        (error) => {
          Sentry.captureException(error);
          reject(error);
        }
      );
    });
  };
}

export default S3FileUploader;
